var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    stroke: "currentColor",
    strokeWidth: 7,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 67l28-29M33 52l17 15"
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT5DaGVja21hcms8L3RpdGxlPgogICAgPGcgaWQ9IkNpcmNsZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iNyIgZmlsbD0ibm9uZSI+CiAgICAgICAgPGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNDUiIC8+CiAgICA8L2c+CiAgICA8ZyBpZD0iQ2hlY2siIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjciIGZpbGw9Im5vbmUiPgogICAgICAgIDxsaW5lIHgxPSI0NSIgeDI9IjczIiB5MT0iNjciIHkyPSIzOCIgLz4KICAgICAgICA8bGluZSB4MT0iMzMiIHgyPSI1MCIgeTE9IjUyIiB5Mj0iNjciIC8+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgCheckmarkCircle as ReactComponent };